<app-details-header
  [post]="post"
  [mode]="mode"
  [isWeb]="isWeb"
  [isGuest]="guest"
  (showGuestModal)="userModal()"
>
</app-details-header>
<div *ngIf="post" class="flex justify-center px-10">
  <div
    class="flex max-w-[1400px] w-full gap-10"
    [ngClass]="{ 'flex-col': isMobile }"
  >
    <app-photo-gallery
      [gallery]="post.images"
      [isMobile]="isMobile"
    ></app-photo-gallery>

    <div
      class="flex flex-col gap-2 pb-6 pt-8 rounded-tr-[25px] mt-[-25px] min-h-[50%] w-full z-10 max-w-[500px]"
      [ngClass]="{ 'px-6': !isMobile }"
    >
      <ion-label class="text-2xl font-medium">{{ post.title }}</ion-label>
      <ion-label class="text-sm">{{ post.address }}</ion-label>
      <div
        class="rounded-md w-fit px-3 py-2 flex items-center"
        [class]="post.type === 'found' ? 'bg-[#4BC287]' : 'bg-[#F34545]'"
      >
        <ion-label class="uppercase text-sm">
          {{ "DETAILS_WEB.OBJECT" | translate }}
          {{
          post.type === "found"
          ? ("DETAILS_WEB.FOUND" | translate)
          : ("DETAILS_WEB.LOST" | translate)
          }}
        </ion-label
        >
      </div>

      <div *ngIf="mode === 'commission'" class="mb-6">
        <hr class="my-6"/>
        <div class="flex gap-4" (click)="navigate('/user-profile/' + post.user.id)">
          <div
            class="h-[38px] w-[38px] rounded-[5px] !bg-cover !bg-center"
            [ngStyle]="{ background: 'url(' + post.user.photo_perfil + ')' }"
          ></div>
          <div class="flex flex-col">
            <ion-label class="text-sm font-medium">{{ post.user.name }}</ion-label>
            <ion-label class="text-[11px] font-light">{{
              "DETAILS_WEB.VIEW_PROFILE" | translate
              }}
            </ion-label>
          </div>
        </div>
      </div>

      <ion-segment mode="md" color="secondary" class="w-full">
        <ion-segment-button value="first" content-id="first" class="flex-1 basis-1/2">
          <ion-label class="capitalize text-sm web-segment-label">{{ "DETAILS_WEB.INFORMATION" | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="second" content-id="second" class="flex-1 basis-1/2">
          <ion-label class="capitalize text-sm web-segment-label p-2">{{ "DETAILS_WEB.ATTRIBUTES" | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>

      <ion-segment-view>
        <ion-segment-content id="first">
          <p class="text-[13px] mt-4">{{ post.description }}</p>
          <!-- Publication date -->
          <ion-label
            class="text-[12px] mt-2 block"
            *ngIf="post?.created_at || post?.published_at || post?.createdAt || post?.publishedAt"
          >
            {{ 'DETAILS_WEB.PUBLICATION_DATE' | translate }}:
            {{ (post.created_at || post.published_at || post.createdAt || post.publishedAt) | date: 'dd/MM/yyyy' }}
          </ion-label>
        </ion-segment-content>
        <ion-segment-content id="second">
          <div class="mt-4 flex flex-col gap-3">
            <div
              *ngFor="let attr of post.article_attributes"
              class="flex items-center justify-between"
            >
              <ion-label class="text-[13px] font-medium"
              >{{ attr.attribute_name }}:
              </ion-label
              >

              <div class="flex items-center gap-2">
                <!-- Para atributos de tipo color, mostrar un círculo del color -->
                <div
                  *ngIf="attr.attribute?.type === 'color'"
                  class="w-5 h-5 rounded-full border border-gray-300"
                  [ngStyle]="{ 'background-color': attr.value }"
                ></div>

                <!-- Valor del atributo -->
                <ion-label
                  *ngIf="attr.attribute?.type !== 'color'"
                  class="text-[13px]"
                >{{ attr.value }}
                </ion-label
                >
              </div>
            </div>

            <!-- Mensaje si no hay atributos -->
            <ion-label
              *ngIf="
                !post.article_attributes || post.article_attributes.length === 0
              "
              class="text-[13px] text-center italic"
            >
              {{ "DETAILS_WEB.NO_ATTRIBUTES" | translate }}
            </ion-label>
          </div>
        </ion-segment-content>
      </ion-segment-view>

      <!-- Informational text about recovery/return intention -->
      <div *ngIf="mode !== 'commission' && !isOwner()" class="public-profile-share-callout mt-4">
        <img
          src="../../../assets/svg/public-profile-share.svg"
          alt=""
          aria-hidden="true"
          class="public-profile-share-callout__icon"
        />
        <p class="public-profile-share-callout__text">
          {{ getInfoTextKey() | translate }}
        </p>
      </div>

      <ion-button
        *ngIf="mode !== 'commission'"
        [disabled]="isOwner()"
        color="primary"
        mode="ios"
        class="app-shadow mt-4"
        (click)="!guest ? openContactRequestDialog() : userModal()"
      >{{ getContactButtonKey() | translate }}
      </ion-button>

      <app-dialog
        [show]="showContactRequestDialog"
        [close]="true"
        (toggle)="cancelContactRequestDialog()"
      >
        <div class="flex flex-col gap-4 p-2 pt-4">
          <ion-label class="text-[13px] leading-snug"
            [innerHTML]="getContactDialogBodyKey() | translate">
          </ion-label>

          <!-- Lost object: user wants to return it → notify the owner -->
          <ng-container *ngIf="post?.type === 'lost'">
            <ion-button size="small" color="primary" class="w-full" (click)="confirmContactRequest()">
              {{ 'DIALOG.NOTIFY_OWNER_BUTTON' | translate }}
            </ion-button>
          </ng-container>

          <!-- Found object: owner wants to recover it → proceed with contact -->
          <ng-container *ngIf="post?.type !== 'lost'">
            <ion-button size="small" color="primary" class="w-full" (click)="confirmContactRequest()">
              {{ 'DIALOG.CONTACT' | translate }}
            </ion-button>
          </ng-container>
        </div>
      </app-dialog>
    </div>
  </div>
</div>
